import { createContext, useContext } from 'react';

import type { TAgeConfirmationContext } from '~context/age-confirmation/types';
import ClientLogger from '~logger/client';
import { LoggerMessages, LoggerServices } from '~logger/constants';

export const AgeConfirmationContext = createContext<TAgeConfirmationContext>({
	openAgeConfirmation: () => undefined,
});

export const useAgeConfirmationContext = () => {
	const context = useContext(AgeConfirmationContext);
	if (!context) {
		ClientLogger.error(
			LoggerServices.AgeConfirmation,
			LoggerMessages.AgeConfirmationContextError,
			{}
		);
		throw Error('AgeConfirmation context no context Provider');
	}
	return context;
};
